function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ash': 'rgb(169, 169, 169)','dark-olive': 'rgb(32, 51, 27)','olive': 'rgb(32, 51, 27)','taupe': 'rgb(173, 138, 88)','navy': 'rgb(21, 37, 63)','black': 'rgb(31, 29, 32)','clay': 'rgb(210, 147, 128)','sangria': 'rgb(66, 0, 0)','bordeaux': 'rgb(66, 0, 0)','faded-olive': 'rgb(109, 143, 96)','matcha': 'rgb(145, 184, 140)','latte': 'rgb(186, 171, 155)','charcoal': 'rgb(70, 70, 70)','sand': 'rgb(233, 222, 203)','strawberry': 'rgb(214, 51, 100)','ice-blue': 'rgb(99, 171, 219)','cement': 'rgb(176, 170, 176)','vintage-black': 'rgb(36, 32, 36)','petrol': 'rgb(35, 82, 132)','raisin': 'rgb(194, 70, 109)','cherry': 'rgb(227, 53, 111)','espresso': 'rgb(41, 26, 14)','heather-grey': 'rgb(212, 208, 212)','lilac': 'rgb(233, 227, 236)','ocean': 'rgb(148, 185, 191)','stone': 'rgb(227, 227, 227)','soft-pink': 'rgb(245, 225, 225)','mushroom': 'rgb(173, 156, 152)','classic-blue': 'rgb(0, 91, 211)','bone': 'rgb(235, 227, 211)','vintage-mushroom': 'rgb(82, 66, 32)','vintage-mint': 'rgb(232, 250, 234)','mint': 'rgb(232, 250, 234)','neon-pink': 'rgb(250, 0, 138)','lemon': 'rgb(254, 250, 188)','cadet': 'rgb(57, 63, 122)','dusty-lilac': 'rgb(220, 208, 224)','chocolate': 'rgb(112, 84, 71)','military': 'rgb(75, 82, 48)','wine': 'rgb(64, 0, 16)','hunter': 'rgb(51, 87, 73)','raspberry': 'rgb(199, 42, 118)','cedar': 'rgb(51, 36, 33)','espresso': 'rgb(112, 84, 71)','loden': 'rgb(91, 115, 91)','biscuit': 'rgb(161, 145, 127)','military-black': 'rgb(75, 82, 48)','cabernet-black': 'rgb(64, 0, 16)','navy': 'rgb(0, 4, 53)','blush': 'rgb(230, 138, 167)','tranquil-blue': 'rgb(104, 136, 217)','mink': 'rgb(133, 94, 44)','forest': 'rgb(17, 41, 25)','rust': 'rgb(183, 65, 14)','avocado': 'rgb(122, 163, 121)','iron': 'rgb(59, 47, 47)','military': 'rgb(75, 83, 32)','oat-heather': 'rgb(214, 210, 201)','heather-ash': 'rgb(214, 210, 201)','suede': 'rgb(138, 111, 90)','cocoa-powder': 'rgb(90, 62, 43)','off-white': 'rgb(243, 241, 236)','putty': 'rgb(198, 191, 182)','blue-haze': 'rgb(42, 52, 135)','bright-orchid': 'rgb(191, 180, 230)','sagebrush': 'rgb(186, 197, 176)','starfish': 'rgb(205, 183, 112)',};

    this.images = {'red-stripe': 'url("//asher.shop/cdn/shop/files/RED-STRIPE_68x.png?v=13485260412750014604")','royal-blue-stripe': 'url("//asher.shop/cdn/shop/files/ROYAL-BLUE-STRIPE_68x.png?v=15192060559528507577")','soft-pink-stripe': 'url("//asher.shop/cdn/shop/files/SOFT-PINK-STRIPE_68x.png?v=11121950937238088814")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
